import {
    buildConfigSliceWithGridSupport,
    useConfigSlice,
    WidgetConfigSliceActionPayloadType,
} from 'widgets/store/configuration/configSlice';
import { WidgetType } from 'widgets/WidgetType';
import {
    CorporateActionsWidgetConfigState,
    initialCorporateActionsConfiguration,
    isLegacyCorporateActionsWidgetConfig,
} from 'widgets/corpActions/widget/store/config/CorporateActionsWidgetConfigState';
import { selectCorporateActionsState } from 'widgets/corpActions/widget/store/selectors';
import { ConfigStateWithGridSupportSupportedActions } from 'widgets/store/grid/reducer';
import { SymbolEventColumn } from 'widgets/corpActions/widget/grid/columnDefinitions';
import { WidgetActionType } from 'widgets/store/actions';

export const buildCorporateActionsConfigSlice = () =>
    buildConfigSliceWithGridSupport(
        WidgetType.CORPORATE_ACTIONS,
        selectCorporateActionsState,
        initialCorporateActionsConfiguration,
        { preProcessor: upgradeLegacyReducerPreProcessor }
    );

export const useCorporateActionsConfigSlice = () =>
    useConfigSlice(buildCorporateActionsConfigSlice());

export type CorporateActionsConfigPayloadType =
    WidgetConfigSliceActionPayloadType<CorporateActionsWidgetConfigState>;

function upgradeLegacyReducerPreProcessor(
    action: ConfigStateWithGridSupportSupportedActions<
        SymbolEventColumn,
        CorporateActionsWidgetConfigState
    >
) {
    if (action.type === WidgetActionType.WIDGET_LOAD_CONFIG) {
        const config = action.payload?.configDelta;
        if (
            (config?.caTypes ?? []).length === 0 &&
            isLegacyCorporateActionsWidgetConfig(config)
        ) {
            (config as Partial<CorporateActionsWidgetConfigState>).caTypes = [
                config.caType!,
            ];
        }
        if (config?.visibleColumns) {
            const oldTypeColNameIdx = config.visibleColumns.indexOf(
                'caType' as SymbolEventColumn
            );
            if (oldTypeColNameIdx > -1) {
                config.visibleColumns[oldTypeColNameIdx] = 'type';
            }
        }
    }
}
